import React, { useState } from "react";
import { InsertDriveFile as FileIcon } from "@mui/icons-material";

import { getImageSRC } from "../../../functions/assets";
import { ImageDetailModal } from "../../../components/Modal/ImageDetailModal";
import {
  formatMessageTime,
  formatMessageTimestamp,
} from "../../../functions/time";
import Box from "@mui/material/Box";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Chip,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { PdfModal } from "../../../components/Modal/PdfModal";

// check naive if the source file is a pdf
const isPDF = (imageSourceForModal) =>
  imageSourceForModal.toLowerCase().endsWith(".pdf");

const MessageListItem = ({ message }) => {
  const theme = useTheme();
  const { author, content, createdAt, attachments } = message;
  const [imageSourceForModal, setImageSourceForModal] = useState(undefined);

  const closeModal = () => setImageSourceForModal(undefined);

  // messages with line breaks from PWA/App (this App)
  let messageRows = content.split("<br />");

  // messages with line breaks from Verwalter
  if (content.includes("\n")) {
    messageRows = content.split("\n");
  }

  const styles = {
    messageItem: {
      marginBottom: theme.spacing(1),
    },
  };

  return (
    <Box sx={styles.messageItem}>
      {/* author and datetime */}
      <Chip
        // icon={<TagFaces />}
        size="small"
        // TODO: Fallback to "Admin" if no author is set
        label={`${author || "Admin"} - ${formatMessageTime(createdAt)}`}
        title={formatMessageTimestamp(createdAt)}
        sx={{ ml: -0.5, mb: 0.5 }}
      />

      {messageRows &&
        messageRows.length &&
        messageRows.map((message, index) => {
          return (
            <Typography key={`${index}`} variant="body2">
              {message}
            </Typography>
          );
        })}

      {/* asset list */}
      <List dense={true}>
        {attachments.map((file) => (
          <ListItem
            key={file.id}
            onClick={() => setImageSourceForModal(getImageSRC(file.filename))}
          >
            <ListItemIcon>
              <FileIcon />
            </ListItemIcon>
            <ListItemText>{file.name}</ListItemText>
          </ListItem>
        ))}
      </List>

      {/* modal */}
      {imageSourceForModal && isPDF(imageSourceForModal) ? (
        <PdfModal source={imageSourceForModal} closeModal={closeModal} />
      ) : (
        <ImageDetailModal
          imageSourceForModal={imageSourceForModal}
          closeModal={closeModal}
        />
      )}
    </Box>
  );
};

export { MessageListItem };
